import {endpoints} from './endpoints'
import request from '../../request'

export function getTreePath(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getTreePath,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getFile(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getFile,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getFolders(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getFolders,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createFolder(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createFolder,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updateFolder(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateFolder,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updateNode(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateNode,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function changeNodesParent(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.changeNodesParent,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteNodes(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteNode,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function restoreNodes(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.restoreNodes,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteFolder(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteFolder,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}